import { Box, Typography } from '@mui/material';
import { theme } from 'config/theme';

type CircularHighlightProps = {
  label: string;
  count: number;
  icon: JSX.Element;
  message: string;
  onClick: () => void;
};

function CircularHighlight({ label, message, count = 0, icon, onClick }: CircularHighlightProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: theme.palette.custom.tuna,
      }}
    >
      <Box sx={{ mb: 1 }}>
        <Typography sx={{ fontWeight: 700, fontSize: 14 }}>{label}</Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: { xs: 100, lg: 120 },
          height: { xs: 100, lg: 120 },
          borderRadius: '50%',
          border: `5px solid ${theme.palette.custom.line}`,
          position: 'relative',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          onClick={onClick}
        >
          <Typography sx={{ fontWeight: 700, fontSize: 22 }}>{count}</Typography>
          <Typography sx={{ color: theme.palette.custom.mistBlue, fontSize: 12 }}>
            {message}
          </Typography>
        </Box>

        <Box
          sx={{
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            bottom: -18,
            background: 'white',
            borderRadius: '50%',
            padding: 1,
          }}
        >
          {icon}
        </Box>
      </Box>
    </Box>
  );
}

export default CircularHighlight;
